<app-popup id="renewalPopup" [overrideOutsideClick]="true">
  <section class="renewal-popup">
    <div>Hello, {{ userProfile?.firstName }}. Please confirm if your previously approved exemption is still valid.</div>
    <div class="btn-block">
      <ods-button (click)="onSubmit(true)" variant="primary">YES</ods-button>
      <ods-button (click)="onSubmit(false)" variant="secondary">NO</ods-button>
    </div>
  </section>
</app-popup>
